// extracted by mini-css-extract-plugin
export var border = "_8r-0";
export var borderSelected = "_8r-1";
export var check = "_8r-6";
export var circle = "_8r-2";
export var circleInner = "_8r-4";
export var circleInnerDisabled = "_8r-8";
export var description = "_8r-3";
export var horizontal = "_8r-b";
export var input = "_8r-5";
export var label = "_8r-9";
export var radioButton = "_8r-d";
export var radioButtonNoCenter = "_8r-e";
export var radioGroup = "_8r-a";
export var rightRadio = "_8r-f";
export var subcontent = "_8r-g";
export var uncheck = "_8r-7";
export var vertical = "_8r-c";